import { render, staticRenderFns } from "./participants-loader.vue?vue&type=template&id=4fe1c5ee"
import script from "./participants-loader.vue?vue&type=script&lang=js"
export * from "./participants-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports